export default __webpack_public_path__ + "static/media/hero-3.23257e46.jpg";